export const getSearchQuery = state => state.search.searchQuery;
export const getSearchQueryField = state => state.search.searchQueryField;



// WEBPACK FOOTER //
// ./src/shared/selectors/search.js